<template>
  <div class="w-full booking-campaign-banner flex align-center margin-t-5" v-if="campaign">
    <div class="flex align-center">
      <div class="booking-campaign-banner__icon spacer-x-2 spacer-y-2"><i class="fa fa-1x fa-clone"></i></div>
      <div class="margin-l-1">Part of campaign: {{ campaign.name }}</div>
    </div>
    <router-link v-if="$userIsAdmin" :to="{ name: 'campaign.edit', params: { id: campaign.id }}" class="margin-r-2">
      <span>View Campaign <i class="fa fa-chevron-right"></i></span>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    campaign: {
      required: true,
      type: Object
    }
  }
}
</script>
